<template>
  <section class="flex flex-col items-center justify-center p-8">
    <p v-if="error" class="text-red mb-4">{{ error }}</p>
    <p v-else class="text-gray-8">Signing you in...</p>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue"
import { useRouter, useRoute } from "vue-router"

const router = useRouter()
const route = useRoute()
const error = ref(null)

function decodeJwtPayload(token) {
  try {
    const base64 = token.split(".")[1]
    if (!base64) return null
    const json = atob(base64.replace(/-/g, "+").replace(/_/g, "/"))
    return JSON.parse(json)
  } catch {
    return null
  }
}

onMounted(() => {
  const token = route.query.token
  if (!token) {
    error.value = "Missing authentication token. Please try signing in again."
    return
  }
  const user = decodeJwtPayload(token)
  if (!user || !user.username) {
    error.value = "Invalid authentication. Please try signing in again."
    return
  }
  localStorage.setItem("access-token", token)
  localStorage.setItem("carl-user", JSON.stringify(user))
  router.replace({ name: "Dashboard" })
})
</script>
